import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ecoType } from '../const';
import ecoConfig from '../config/index';
var RECORD_PROTOCOL_MAP = {
  qywx: {
    startEvent: 'startRecord',
    stopEvent: 'stopRecord',
    result: 'tempFilePath'
  },
  wx: {
    startEvent: 'startRecord',
    stopEvent: 'stopRecord',
    result: 'tempFilePath'
  },
  dingTalk: {
    startEvent: 'device.audio.startRecord',
    stopEvent: 'device.audio.stopRecord',
    result: 'mediaId'
  },
  fs: {
    // 暂时不支持
    startEvent: 'start',
    stopEvent: 'stop',
    result: 'mediaId'
  }
};

var RecorderManager = /*#__PURE__*/function () {
  // 录音最长时间
  // 录音文件地址
  // 录音状态
  // 开始录音时间
  // 结束录音时间
  function RecorderManager() {
    this.protocol = null;
    this.maxDuration = 60;
    this.recordObj = null;
    this.status = 'start';
    this.startTime = 0;
    this.endTime = 0;
  }
  /**
   * 开始录音
   * @param params 
   * @param params.maxDuration 录音最长时间 [1, 300],默认60秒
   * @returns 
   */


  var _proto = RecorderManager.prototype;

  _proto.startRecord =
  /*#__PURE__*/
  function () {
    var _startRecord = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
      var _this = this;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve, reject) {
                  var configInstanse, recordProtocolConfig;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          configInstanse = ecoConfig(ecoType);
                          recordProtocolConfig = RECORD_PROTOCOL_MAP[ecoType];
                          _this.maxDuration = params && params.maxDuration || 60;
                          return _context.abrupt("return", configInstanse.protocol(recordProtocolConfig.startEvent, params).then(function () {
                            _this.status = 'start';
                            _this.startTime = Date.now();

                            _this.onStop();

                            resolve();
                          }));

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }()));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function startRecord(_x) {
      return _startRecord.apply(this, arguments);
    }

    return startRecord;
  }()
  /**
   * 停止录音
   * @param params 
   * @returns 
   */
  ;

  _proto.stopRecord = function stopRecord(params) {
    var _this2 = this;

    return new Promise( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve, reject) {
        var configInstanse, recordProtocolConfig;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                configInstanse = ecoConfig(ecoType);
                recordProtocolConfig = RECORD_PROTOCOL_MAP[ecoType];
                return _context3.abrupt("return", configInstanse.protocol(recordProtocolConfig.stopEvent, params).then(function (res) {
                  _this2.status = 'stop';
                  _this2.endTime = Date.now();
                  var time = ((_this2.endTime - _this2.startTime) / 1000).toFixed(1);
                  _this2.recordObj = {
                    key: res[recordProtocolConfig.result],
                    time: res.duration || time
                  };
                  resolve(res);
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }());
  }
  /**
   * 自动到期停止
   */
  ;

  _proto.onStop = function onStop() {
    var _this3 = this;

    var stopTimeout = setTimeout(function () {
      if (_this3.status === 'start') {
        _this3.stopRecord();
      } else {
        clearTimeout(stopTimeout);
        stopTimeout = null;
      }
    }, this.maxDuration * 1000);
  };

  return RecorderManager;
}();

export default RecorderManager;